// import { SHA256 } from 'crypto-js';
import * as CryptoJS from 'crypto-js';

const PALETTE = ['#247BED', '#D67722', '#2F9EBA', '#955CDB', '#CC5049', '#C8548E', '#C7518B', '#3FA91F', '#2894AF'];

/**
 * Генерирует цвет на основе имени пользователя, используя хеш-функцию.
 * @param name ФИО пользователя
 * @param palette Палитра цветов
 * @returns Цвет из палитры
 */
export const generateColor = (name: string, palette: string[] = PALETTE): string => {
  // Хешируем имя, используя SHA-256
  const hashedName = CryptoJS.SHA256(name).toString(CryptoJS.enc.Hex);

  // Преобразуем хеш в целое число
  const hashInt = parseInt(hashedName, 16);

  // Используем целое число хеша для выбора цвета из палитры
  const colorIndex = hashInt % palette.length;
  const color = palette[colorIndex];

  return color;
};
